import Image from "@/components/Image/ImageSecondary";
import { StyledTableCell } from "@/components/Table/CustomTable";
import { Box, Checkbox, Typography } from "@mui/material";
import { CtvChannel } from "./ctvChannels.interface";

const VISITOR_INSIGHTS_IMAGE_URL = import.meta.env
  .VITE_APP_VISITOR_INSIGHTS_IMAGE_URL;

interface ChannelsTableRowProps {
  row: CtvChannel;
  onToggleSave: (channel: CtvChannel) => void;
  savedChannels: Record<string, CtvChannel>;
}

export default function ChannelsTableRow({
  row,
  onToggleSave,
  savedChannels,
}: ChannelsTableRowProps) {
  // Check if channel is saved either in API data or local state

  const isSaved = Boolean(savedChannels[row?.id]);
  return (
    <>
      <StyledTableCell align="center">
        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
          <Checkbox
            checked={isSaved}
            onChange={() => onToggleSave(row)}
            color="primary"
          />
          <Image
            img={VISITOR_INSIGHTS_IMAGE_URL + row?.domain}
            alt="logo"
            maxWidth="40px"
            maxHeight="40px"
          />
        </Box>
      </StyledTableCell>
      <StyledTableCell align="left">{row?.name}</StyledTableCell>
      <StyledTableCell align="left">
        {row?.Categories?.[0]?.name}
      </StyledTableCell>
      <StyledTableCell align="left">
        {row?.Categories?.[0]?.subCategories?.[0]?.name}
      </StyledTableCell>
      <StyledTableCell align="left">
        {/* No Tooltip — the app-level OverflowTooltip reveals this from the
            ellipsis styling, and wrapping it here showed two at once. */}
        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "200px",
          }}
        >
          {row?.description}
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="left">
        ${row?.floorCpm?.toFixed(2)}
      </StyledTableCell>
    </>
  );
}
